/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Progress_Extra_Map_LabelInputs */

const en_us2_progress_extra_map_label = /** @type {(inputs: Progress_Extra_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Map of the muscles worked this week: ${i?.names}`)
};

const pt_br2_progress_extra_map_label = /** @type {(inputs: Progress_Extra_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa dos músculos trabalhados nesta semana: ${i?.names}`)
};

const es_419_progress_extra_map_label = /** @type {(inputs: Progress_Extra_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa de los músculos trabajados esta semana: ${i?.names}`)
};

const pt_pt2_progress_extra_map_label = /** @type {(inputs: Progress_Extra_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mapa dos músculos trabalhados esta semana: ${i?.names}`)
};

const fr_fr2_progress_extra_map_label = /** @type {(inputs: Progress_Extra_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carte des muscles travaillés cette semaine : ${i?.names}`)
};

const de_de2_progress_extra_map_label = /** @type {(inputs: Progress_Extra_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Karte der diese Woche trainierten Muskeln: ${i?.names}`)
};

const it_it2_progress_extra_map_label = /** @type {(inputs: Progress_Extra_Map_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mappa dei muscoli allenati questa settimana: ${i?.names}`)
};

/**
* | output |
* | --- |
* | "Map of the muscles worked this week: {names}" |
*
* @param {Progress_Extra_Map_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_map_label = /** @type {((inputs: Progress_Extra_Map_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Map_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_map_label(inputs)
	if (locale === "es-419") return es_419_progress_extra_map_label(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_map_label(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_map_label(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_map_label(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_map_label(inputs)
	return en_us2_progress_extra_map_label(inputs)
});
export { progress_extra_map_label as "progress-extra.map_label" }